export const PRIMARY_ACTION_TOKENS = {
  main: 'var(--color-action-primary)',
  hover: 'var(--color-action-primary-hover)',
  hoverStrong: 'var(--color-action-primary-hover-strong)',
  contrastText: 'var(--color-action-primary-contrast)',
  focusRing: 'var(--color-action-primary-focus-ring)',
  shadow: 'var(--shadow-action-primary-sm)',
  shadowHover: 'var(--shadow-action-primary-md)'
}

export const SECONDARY_ACTION_TOKENS = {
  border: 'var(--color-action-neutral-border)',
  text: 'var(--color-action-neutral-text)',
  background: 'var(--color-action-neutral-bg)',
  borderHover: 'var(--color-action-neutral-border-hover)',
  backgroundHover: 'var(--color-action-neutral-bg-hover)'
}

export const DISABLED_ACTION_TOKENS = {
  background: 'var(--color-action-disabled-bg)',
  border: 'var(--color-action-disabled-border)',
  text: 'var(--color-action-disabled-text)'
}
